// extracted by css-extract-rspack-plugin
export default {"cls1":"useTabs-cls1_Z9y","cls2":"useTabs-cls2_tlV useTabs-cls1_Z9y","active":"useTabs-active_kfC"};